import { defineComponent, h, provide, renderSlot, toRefs } from 'vue'
import { useNamespace } from '@jdesign-vue/hooks'

const Timeline = defineComponent({
  name: 'JdTimeline',
  props: {
    mode: {
      type: String,
      values: ['left', 'right', 'alternate'],
      default: 'right',
    },
  },
  setup(props, { slots }) {
    const ns = useNamespace('timeline')
    const { mode } = toRefs(props)

    provide('timeline', slots)

    /**
     *  Maybe ,this component will not support prop 'reverse', why ?
     *
     *  Example 1:
     *   <component-a>
     *     <div>1</div>
     *     <div>2</div>
     *   </component-a>
     *
     *  Example 2:
     *   <component-a>
     *     <div v-for="i in 2" :key="i">{{ i }}</div>
     *   </component-a>
     *
     *  'slots.default()' value in example 1 just like [Vnode, Vnode]
     *  'slots.default()' value in example 2 just like [Vnode]
     *
     *   so i can't reverse the slots, when i use 'v-for' directive.
     */

    return () => {
      return h('ul', { class: [ns.b(), ns.is(`${mode}`)] }, [
        renderSlot(slots, 'default'),
      ])
    }
  },
})

export default Timeline
export type TimelineInstance = InstanceType<typeof Timeline>
